module.exports = __webpack_public_path__ + "5490a1aad48d43959eaa87f0a00877f0.MP3";